import { Component, inject, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import School from '@account/School'
import { SchoolsService } from '@account/Services/SchoolsService'
import { Table } from '@ui/Table'
import HttpError from '@ui/HttpError'
import Pagination from '@ui/Pagination'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { DialogActionsComponent } from '@ui/Components/Dialog/DialogActions.Component'
import { NgStyle } from '@angular/common'
import { CdkTableComponent } from '@ui/Components/Table/CdkTable.Component'
import { ButtonComponent } from '@ui/Components/Form/Button/Button.Component'
import ClassCategory from '@account/ClassCategory'
import { PaginatorComponent } from '@ui/Components/Paginator/Paginator.Component'
import { InputValue } from '@ui/Components/Form/TextInput/TextInput.Component'
import { DebouncedTextFilterComponent } from '@ui/Components/Filters/DebouncedTextFilter.Component'

@Component({
	selector: 'school-list-dialog',
	templateUrl: './SchoolListDialog.Component.html',
	imports: [
		DialogComponent,
		DialogActionsComponent,
		NgStyle,
		CdkTableComponent,
		ButtonComponent,
		PaginatorComponent,
		DebouncedTextFilterComponent,
	],
})
export class SchoolListDialogComponent extends Table<School> implements OnInit {
	public category: ClassCategory

	public selectedSchoolId: number

	protected readonly schoolsService: SchoolsService

	private readonly dialogRef: MatDialogRef<SchoolListDialogComponent>

	constructor() {
		super()

		this.dialogRef = inject(MatDialogRef<SchoolListDialogComponent>)
		this.schoolsService = inject(SchoolsService)

		this.schoolsService.clearLocalStorageKey().resetFilter()
	}

	public ngOnInit() {
		this.displayColumns = ['name', 'select']

		this.tableEntities = [
			{
				columnDef: 'name',
				accessorKey: 'name',
				header: 'Name',
			},
			{
				columnDef: 'select',
				type: 'action',
				header: 'Select',
				action: {
					title: 'Select',
					color: 'primary',
					output: (school: School): void => {
						this.closeWithSchool(school)
					},
					disabled: (school: School): boolean => {
						return this.selectedSchoolId === school.id
					},
				},
			},
		]

		void this.fetchSchools()
	}

	public close(): void {
		this.dialogRef.close()
	}

	public closeWithSchool = (school: School): void => {
		this.dialogRef.close(school)
	}

	protected readonly filterName = async (name: InputValue): Promise<void> => {
		this.schoolsService.filterable.name = name as string

		await this.fetchSchools()
	}

	protected readonly setPaginator = async (
		paginator: Pagination,
	): Promise<void> => {
		this.schoolsService.setPaginator(paginator)

		await this.fetchSchools(false)
	}

	private readonly fetchSchools = async (
		resetPaginator: boolean = true,
	): Promise<void> => {
		try {
			this.schoolsService.filterable.categories = [this.category]

			if (resetPaginator) {
				this.schoolsService.paginatorInit(true)
			}

			const schools = await this.schoolsService.filter()

			this.setTableData(schools)
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
